import VueGoodTablePlugin from 'vue-good-table-next';

// Import the styles
import 'vue-good-table-next/dist/vue-good-table-next.css';

export default defineNuxtPlugin(nuxtApp => {
  // Register VueGoodTablePlugin
  nuxtApp.vueApp.use(VueGoodTablePlugin);
});
